import {
	format,
	startOfMonth,
	endOfMonth,
	subDays,
	subMonths,
} from "date-fns";

export const getCurrentMonthRange = () => ({
	from: format(startOfMonth(new Date()), "yyyy-MM-dd"),
	to: format(endOfMonth(new Date()), "yyyy-MM-dd"),
});

export const DATE_PRESETS = {
	currentMonth: getCurrentMonthRange,
	yesterday: () => {
		const day = format(subDays(new Date(), 1), "yyyy-MM-dd");
		return { from: day, to: day };
	},
	last7Days: () => ({
		from: format(subDays(new Date(), 6), "yyyy-MM-dd"),
		to: format(new Date(), "yyyy-MM-dd"),
	}),
	lastMonth: () => {
		const prev = subMonths(new Date(), 1);
		return {
			from: format(startOfMonth(prev), "yyyy-MM-dd"),
			to: format(endOfMonth(prev), "yyyy-MM-dd"),
		};
	},
};
